// src/pages/KeyFactStatement.js

import React from 'react';
import './key-fact-statement.css';
import './terms-conditions.css';

const keyFacts = [
  ["Loan Amount", "Total Amount Sanctioned (Principal Amount)"],
  ["Total Interest Charge", "Up to 1% Per Day (Calculated on reducing balance/flat as per agreement)"],
  ["Processing Fee (Including GST)", "8% to 15% of the Loan Amount (Upfront deduction)"],
  ["Insurance Charges, If Any", "Not Applicable / As per actuals (if opted)"],
  ["Net Disbursed Amount", "Loan Amount minus Processing Fees & applicable charges"],
  ["Total Amount To Be Paid By Borrower", "Sum of Principal, Total Interest, and all other charges"],
  ["Annual Percentage Rate (APR)", "120% to 365% (Inclusive of all costs)"],
  ["Tenure of the Loan", "30 to 90 Days"],
  ["Repayment Frequency", "Single Bullet Payment / Monthly Installments"],
  ["Number of Installments", "1 to 3 Installments"],
  ["Cooling Off / Look-Up Period", "3 Days (As per RBI guidelines)"],
  ["__SECTION__", "Details About Contingent Charges"],
  ["Penal Charges / Late Payment Fees", "Up to 3% Per Month on the overdue amount"],
  ["Foreclosure / Prepayment Charges", "Nil (For Payday Loans) / Up to 5% + GST for other products"],
  ["__SECTION__", "Grievance Redressal Officer (Digital Lending)"],
  ["Name", "Jitender Kumar"],
  ["Designation", "Grievance Redressal Officer"],
  ["Office Address", "A-29, Mangolpuri Industrial Area, Phase - II, Delhi, 110034"],
  ["Contact Details", "Phone: 9910739751 | Email: grievance@loanonsalary.com"]
];

const KeyFactStatement = () => {
  let srNo = 1;

  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        {/* Fix: Title updated to Key Fact Statement */}
        <h1>Key Fact Statement (KFS)</h1>
      </header>

      <section className="tc-content mb-3">
        <p className="text-muted mb-4 text-center">
          <i>This statement provides the key facts of your loan. Please read it carefully before proceeding.</i>
        </p>

        <div className="table-responsive">
          <table className="kfs-table">
            <thead>
              <tr>
                <th style={{ width: '8%' }}>Sr. No.</th>
                <th style={{ width: '42%' }}>Parameter</th>
                <th style={{ width: '50%' }}>Details</th>
              </tr>
            </thead>
            <tbody>
              {keyFacts.map(([param, detail], index) => {
                if (param === "__SECTION__") {
                  // Reset numbering logically if you want or keep it running
                  return (
                    <tr key={`section-${index}`}>
                      <td colSpan="3" className="section-heading text-center fw-bold bg-light p-3">
                        {detail}
                      </td>
                    </tr>
                  );
                }

                return (
                  <tr key={index}>
                    <td className="text-center"><strong>{srNo++}</strong></td>
                    <td>{param}</td>
                    <td>{detail}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        
        <div className="mt-4 p-3 border rounded bg-light">
          <small>
            *The APR mentioned above is an estimate. The actual APR and charges will be specifically 
            provided in the Sanction Letter based on the borrower's credit assessment.
          </small>
        </div>
      </section>
    </div>
  );
};

export default KeyFactStatement;